import {
  Box,
  BoxProps,
  Flex,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { RefObject } from 'react';
import { useSelector } from 'react-redux';
import { Creator } from '~/clientApi/creator.model';
import { selectCreator } from '~/selectors/creator';

import { NavigationLink } from '../../ShareNavBar.model';
import { CreatorName } from '../CreatorName/CreatorName';
import { NavLinks } from '../NavLinks';
import { ToggleIcon } from './components/ToggleIcon';

interface Props extends BoxProps {
  activeSection: number;
  navigationLinks: NavigationLink[];
  sectionsRefs: RefObject<HTMLElement>[];
}

export const ToggleMenu: React.FC<Props> = ({
  activeSection,
  navigationLinks,
  sectionsRefs,
  ...props
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const creator = useSelector(selectCreator);

  return (
    <Flex data-testid="nav-bar-toggle-menu">
      <ToggleIcon isOpen={isOpen} onClose={onClose} onOpen={onOpen} />

      {!isMobile && (
        <CreatorName
          creator={creator as Creator}
          fontWeight="medium"
          fontSize="xl"
        />
      )}

      <Box
        position="fixed"
        top="54px"
        left={0}
        width="100%"
        height="100vh"
        backgroundColor="primary.500"
        transform={`translateX(${isOpen ? '0%' : '-100%'})`}
        transition="transform 0.2s"
        zIndex="dropdown"
        {...props}
      >
        <Flex direction="column" marginLeft={{ base: 8, md: '72px' }}>
          {isMobile && (
            <CreatorName
              creator={creator as Creator}
              marginTop={10}
              color="white"
              fontWeight="medium"
              fontSize="3xl"
            />
          )}

          <NavLinks
            navigationLinks={navigationLinks}
            activeIndex={activeSection}
            marginTop={10}
            onClick={onClose}
            fontSize="xl"
            sectionsRefs={sectionsRefs}
          />
        </Flex>
      </Box>
    </Flex>
  );
};
